import * as React from "react";

export default function ModalCloseIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 50 50" {...props}>
			<path d="M47.2 8.8c1.6-1.6 1.6-4.1 0-5.6l-.4-.4c-1.6-1.6-4.1-1.6-5.6 0L25.7 18.3c-.4.4-1 .4-1.4 0L8.8 2.8c-1.6-1.6-4.1-1.6-5.6 0l-.4.4c-1.6 1.6-1.6 4.1 0 5.6l15.5 15.5c.4.4.4 1 0 1.4L2.8 41.2c-1.6 1.6-1.6 4.1 0 5.6l.4.4c1.6 1.6 4.1 1.6 5.6 0l15.5-15.5c.4-.4 1-.4 1.4 0l15.5 15.5c1.6 1.6 4.1 1.6 5.6 0l.4-.4c1.6-1.6 1.6-4.1 0-5.6L31.7 25.7c-.4-.4-.4-1 0-1.4L47.2 8.8z" />
		</svg>
	);
}
